import styled from '@emotion/styled';
import { DialogTemplate, Paragraph2, Paragraph1 } from 'inpock-ui-react';

import { Box } from '@/components';
const DialogModuleName = 'nonUser.tsx';

const Template = {
  signup: (click: () => void) => {
    return (
      <DialogTemplate
        moduleName={DialogModuleName}
        classSuffix="signup"
        title="구매하기"
        message={
          <Box flex alignItems="center" justifyContent="center" flexDirection="column">
            <Paragraph1 fontWeight="regular" className="mb-8">
              지금 로그인하여 구매하시면
              <br /> 더 간편하게 구매가 가능해요 ☺️
            </Paragraph1>
            <div onClick={click}>
              <UnderlineGraph color="gray500">비회원으로 구매할게요</UnderlineGraph>
            </div>
          </Box>
        }
      />
    );
  },
  expired: () => {
    return (
      <DialogTemplate
        moduleName={DialogModuleName}
        classSuffix="expired"
        title="로그인 만료"
        message={
          <Box flex alignItems="center" justifyContent="center" flexDirection="column">
            <Paragraph1 fontWeight="regular" className="mb-8">
              로그인 정보가 만료되었어요.
            </Paragraph1>
          </Box>
        }
      />
    );
  },
};

export default Template;

const UnderlineGraph = styled(Paragraph2)`
  width: fit-content;
  cursor: pointer;
  text-decoration: underline;
`;
